import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.627 3.904a.7.7 0 0 1 .746 0l6.3 3.963a.7.7 0 0 1 0 1.185l-6.3 3.962a.7.7 0 0 1-.746 0l-6.3-3.962a.7.7 0 0 1 0-1.185l6.3-3.963Zm-6.52 7.264a.7.7 0 0 1 .966-.22L10 14.676l5.927-3.728a.7.7 0 1 1 .746 1.185l-6.3 3.963a.7.7 0 0 1-.746 0l-6.3-3.963a.7.7 0 0 1-.22-.965Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
